import { prepareMessages } from '@ci/message/node';

export const m = prepareMessages('formatters', [
	['T', 'K', 'Symbol after abbreviated thousand number (e.g. 12,000 = 12 K)'],
	['M', 'M', 'Symbol after abbreviated million number (e.g. 12,000,000 = 12 M)'],
	['B', 'B', 'Symbol after abbreviated billion number (e.g. 12,000,000,000 = 12 B)'],
	['maskedAmount', '*****'],
]);
